export default "__VITE_ASSET__COBFtCMv__"